import {applyMiddleware, createStore, compose} from 'redux'
import thunk from 'redux-thunk';

import rootReducer from '../reducers'
import * as ActionTypes from '../actions'

const store = createStore(rootReducer, applyMiddleware(thunk));
store.dispatch(ActionTypes.fetchCart());
export default store;
